import { render, staticRenderFns } from "./tableDeleted.vue?vue&type=template&id=89daf01a"
import script from "./tableDeleted.vue?vue&type=script&lang=js"
export * from "./tableDeleted.vue?vue&type=script&lang=js"
import style0 from "./tableDeleted.vue?vue&type=style&index=0&id=89daf01a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports